/* with love from shopstory */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var valueParser = require('postcss-value-parser');
var parser = require('./parser.cjs');
var reducer = require('./lib/reducer.cjs');
var stringifier = require('./lib/stringifier.cjs');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var valueParser__default = /*#__PURE__*/_interopDefaultLegacy(valueParser);

const MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;
function calculateAllViewportValues(ast, map) {
  if (typeof ast === "object" && ast !== null) {
    if (ast.type === "VwValue" && ast.unit === "vw" && typeof map.vw === "number") {
      return {
        type: "LengthValue",
        unit: "px",
        value: ast.value / 100 * map.vw
      };
    } else if (ast.type === "PercentageValue" && ast.unit === "%" && typeof map.percent === "number") {
      return {
        type: "LengthValue",
        unit: "px",
        value: ast.value / 100 * map.percent
      };
    } else {
      for (const key in ast) {
        if (typeof ast[key] === "object" && ast[key] !== null) {
          ast[key] = calculateAllViewportValues(ast[key], map);
        }
      }
    }
  }
  return ast;
}
function reduceCSSCalc(value) {
  let precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  let map = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return valueParser__default["default"](value).walk(node => {
    // skip anything which isn't a calc() function
    if (node.type !== "function" || !MATCH_CALC.test(node.value)) return;

    // stringify calc expression and produce an AST
    const contents = valueParser__default["default"].stringify(node.nodes);

    // skip constant() and env()
    if (contents.indexOf("constant") >= 0 || contents.indexOf("env") >= 0) return;
    const ast = calculateAllViewportValues(parser.parser.parse(contents), map);

    // reduce AST to its simplest form, that is, either to a single value
    // or a simplified calc expression
    const reducedAst = reducer.reducer(ast, precision);

    // stringify AST and write it back
    node.type = "word";
    node.value = stringifier.stringifier(node.value, reducedAst, precision);
  }, true).toString();
}

exports.reduceCSSCalc = reduceCSSCalc;
